/* eslint-disable @typescript-eslint/no-explicit-any */
import en from "./en";
import fr from "./fr";
export const locales = ["fr", "en"] as const;
const rawLocale = typeof window === "undefined" ? "en" : (window.navigator.languages[0] ?? "en");
export const locale = rawLocale.toLowerCase().startsWith("fr") ? "fr" : "en";
export const translationLocale = locale;
const translations = translationLocale === "fr" ? fr : en;
interface TranslationMap {
  [key: string]: string | ((...args: any) => any);
}

function getTranslationFunction<T extends TranslationMap>(translations: T) {
  return function t<K extends keyof T, V extends T[K]>(
    k: K,
    ...args: V extends (...args: any) => any ? Parameters<V> : never[]
  ): string {
    return typeof translations[k] === "string"
      ? translations[k]
      : (translations[k] as any)(...(args as any));
  };
}
const t = getTranslationFunction(translations);

export default t;
